import React, { useEffect, useState } from 'react'
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar'
// import ReportImg2 from '../../../../../assets/images/report-2.png'
// import ReportImg3 from '../../../../../assets/images/report-3.png'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { createReport, getDefaultReport, getReportList, stopEditMode } from '../../../../../store/actions/reportAction'
import { useVerifySurveyId } from '../../../../../hooks'
import { getTokenData } from '../../../../../store/actions/authAction'
import ReportCard from './components/ReportCard'
import { CLEAR_REPORT_DETAILS, SET_CURRENT_REPORT } from '../../../../../store/constant'
import Svg from '../../../../../component/common/Svg'
import { useTranslation } from 'react-i18next';

export default function RecentReports() {
    //==> State <==
    const [userId, setuserId] = useState('');

    //Selector
    const { survey_name } = useSelector((state) => state.permissionsData)
    const { reportData, defaultReport } = useSelector((state) => state.reportData)
    console.log("survey_name",survey_name);
    
     const { t, i18n } = useTranslation();

    //Others
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const survey_id = useVerifySurveyId()
    const language_code = '22'


    //==> FUNCTIONALITIES <==
    const handleCreateReport = () => {
        const afterAdd = () => {
            navigate(`/admin/survey/report/templates?survey_id=${survey_id}`)
        }
        const payload = {
            language_code: language_code,
            user: userId,
            name: '',
            survey_id: survey_id
        }
        dispatch(createReport(payload, afterAdd))
        dispatch(stopEditMode())
    }

    const handleEditReport = ({ su_survey_report_id }) => {
        dispatch({ type: SET_CURRENT_REPORT, payload: su_survey_report_id })
        navigate(`/admin/survey/report/templates?survey_id=${survey_id}`)
    }


    //==> EFFECTS <==
    useEffect(() => {
        dispatch(getTokenData(setuserId))
    }, [userId, dispatch])

    useEffect(() => {
        if (survey_id) {
            dispatch(getReportList({ survey_id }))
            dispatch(getDefaultReport(survey_id))
            console.log('defaultReport', defaultReport)
            console.log('defaultReport', Object.keys(defaultReport).length)
        }
    }, [survey_id, dispatch])

    useEffect(() => {
        dispatch({ type: SET_CURRENT_REPORT, payload: null })
        dispatch({ type: CLEAR_REPORT_DETAILS })
    }, [])


    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper main-site-wrapper'>
                <SurveyListHeader />
                <div id="viewport" className="d-flex">
                    <SurveyListSidebar />
                    <div className="flex-grow-1">
                        <div className="survey-main-container">
                            <div className="survey-container">
                                <div className="reports-wrap">
                                    <div className="page-heading">
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <Link to="/admin/survey/list">{t('survey.title')}</Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name ?? 'Draft survey'}</Link>
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page"><strong>{t('survey.report.title')}</strong></li>
                                            </ol>
                                        </nav>
                                        <h2>{t('survey.report.create')}</h2>
                                        {/* <a href="#" className='see-all'>Browse all</a> */}
                                    </div>
                                    <div className="report-list">
                                        <div className="row">
                                            <div className="col-lg-3 col-md-6">
                                                {window.modulePermissions.M13.add == 1 && (<div className="report-inner add-report" onClick={() => handleCreateReport()}>
                                                    <div className="report-img">
                                                        <svg width={73} height={73} viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M18.25 36.5H54.75" stroke="#728095" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M36.5 54.75V18.25" stroke="#728095" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </div>
                                                    <div className="report-title mt-1">{t('survey.report.new')} </div>
                                                    <div className="subtitle">{t('survey.report.scratch')}</div>
                                                </div>)}
                                            </div>

                                            {(defaultReport.length!=undefined || Object.keys(defaultReport).length>0) && <div className="col-lg-3">
                                                <div className="report-inner">
                                                    <div className="report-img mb-1" onClick={() => handleEditReport(defaultReport)}>
                                                        <h4>{t('survey.report.template1')}</h4>
                                                    </div>
                                                    <div className="d-flex align-items-start">
                                                        <div className="flex-grow-1 pe-2">
                                                            <div className="report-title mt-1" onClick={() => handleEditReport(defaultReport)}>{`Default template (${defaultReport.su_survey_report_name && JSON.parse(defaultReport.su_survey_report_name)[language_code]})`}</div>
                                                            <div className="subtitle">{t('survey.report.text1')}</div>
                                                        </div>
                                                        {/* <div className="dropdown table-dropdown">
                                                            <button className="btn dropdown-tgl" type="button" id="viewoptions" data-bs-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false">
                                                                <Svg name="action" />
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="viewoptions">

                                                                <span className="dropdown-item d-flex align-items-center">
                                                                    <div className="icon-circle me-3">
                                                                        <Svg name="Edit-Survey" />
                                                                    </div>
                                                                    <span>Edit</span>
                                                                </span>

                                                                <span className="dropdown-item d-flex align-items-center">
                                                                    <div className="icon-circle me-3">
                                                                        <Svg name="duplicate" />
                                                                    </div>
                                                                    <span>Duplicate</span>
                                                                </span>

                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>}


                                            {/* 
                                            <div className="col-lg-3">
                                                <Link to="" className="report-inner">
                                                    <div className="report-img">
                                                        <img src={ReportImg2} className="img-fluid" />
                                                    </div>
                                                    <div className="report-title">Pre-sales Blue theme template</div>
                                                </Link>
                                            </div>
                                            <div className="col-lg-3">
                                                <Link to="" className="report-inner">
                                                    <div className="report-img">
                                                        <img src={ReportImg3} className="img-fluid" />
                                                    </div>
                                                    <div className="report-title">Pre-sales Blue theme template</div>
                                                </Link>
                                            </div> */}

                                        </div>
                                        {/* On Click of Load More 8 more grid items will load - infinite loading*/}
                                        {/* <div className="button-wrap text-center mb-3 mb-md-4">
                                            <button className='btn btn-bordered'>Load More</button>
                                        </div> */}
                                    </div>
                                    <div className="report-list">
                                        <div className="heading mb-3">
                                            <h2>{t('survey.report.recently')}</h2>
                                        </div>
                                        <div className="row">

                                            {
                                                reportData && reportData.length > 0 && reportData.map((report, index) => {
                                                    return (
                                                        <ReportCard
                                                            key={index}
                                                            report={report}
                                                            language_code={language_code}
                                                        />
                                                    )
                                                })
                                            }

                                            {
                                                reportData && reportData.length == 0 && 
                                                <div className="col-lg-3">
                                                   {t('survey.report.no')}   
                                                </div>
                                            }

                                            {/* 
                                            <div className="col-lg-3">
                                                <Link to="" className="report-inner">
                                                    <div className="report-img">
                                                        <img src={ReportImg2} className="img-fluid" />
                                                    </div>
                                                    <div className="report-title">Pre-sales Blue theme template</div>
                                                </Link>
                                            </div>
                                            <div className="col-lg-3">
                                                <Link to="" className="report-inner">
                                                    <div className="report-img">
                                                        <img src={ReportImg3} className="img-fluid" />
                                                    </div>
                                                    <div className="report-title">Pre-sales Blue theme template</div>
                                                </Link>
                                            </div> */}

                                        </div>
                                        {/* On Click of Load More 8 more grid items will load - infinite loading*/}
                                        {/* <div className="button-wrap text-center mb-3 mb-md-4">
                                            <button className='btn btn-bordered'>Load More</button>
                                        </div> */}
                                    </div>
                                </div>

                                {/* <div className="reports-wrap">
                                    <div className="page-heading">
                                        <h2>Recently edited</h2>
                                    </div>
                                    <div className="report-list recently-edited">
                                        <div className="row">
                                            <div className="col-lg-3">
                                                <div className="report-inner">
                                                    <a className="report-img">
                                                        <img src={ReportImg1} className="img-fluid" />
                                                    </a>
                                                    <div className="report-text">
                                                        <a className='report-title'>Lumen survey report</a>
                                                        <ul className='mata-info'>
                                                            <li>In <a href="">team project</a></li>
                                                            <li>Edited 4 minutes ago</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <div className="report-inner">
                                                    <a className="report-img">
                                                        <img src={ReportImg2} className="img-fluid" />
                                                    </a>
                                                    <div className="report-text">
                                                        <a className='report-title'>Tech.info survey report</a>
                                                        <ul className='mata-info'>
                                                            <li>In <a href="">team project</a></li>
                                                            <li>Edited 10 minutes ago</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <div className="report-inner">
                                                    <a className="report-img">
                                                        <img src={ReportImg3} className="img-fluid" />
                                                    </a>
                                                    <div className="report-text">
                                                        <a className='report-title'>Lumen survey report</a>
                                                        <ul className='mata-info'>
                                                            <li>In <a href="">team project</a></li>
                                                            <li>Edited 4 minutes ago</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <div className="report-inner">
                                                    <a className="report-img">
                                                        <img src={ReportImg1} className="img-fluid" />
                                                    </a>
                                                    <div className="report-text">
                                                        <a className='report-title'>Lumen survey report</a>
                                                        <ul className='mata-info'>
                                                            <li>In <a href="">team project</a></li>
                                                            <li>Edited 4 minutes ago</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <div className="report-inner">
                                                    <a className="report-img">
                                                        <img src={ReportImg2} className="img-fluid" />
                                                    </a>
                                                    <div className="report-text">
                                                        <a className='report-title'>Tech.info survey report</a>
                                                        <ul className='mata-info'>
                                                            <li>In <a href="">team project</a></li>
                                                            <li>Edited 10 minutes ago</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <div className="report-inner">
                                                    <a className="report-img">
                                                        <img src={ReportImg3} className="img-fluid" />
                                                    </a>
                                                    <div className="report-text">
                                                        <a className='report-title'>Lumen survey report</a>
                                                        <ul className='mata-info'>
                                                            <li>In <a href="">team project</a></li>
                                                            <li>Edited 4 minutes ago</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <div className="report-inner">
                                                    <a className="report-img">
                                                        <img src={ReportImg1} className="img-fluid" />
                                                    </a>
                                                    <div className="report-text">
                                                        <a className='report-title'>Tech.info survey report</a>
                                                        <ul className='mata-info'>
                                                            <li>In <a href="">team project</a></li>
                                                            <li>Edited 10 minutes ago</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
